import _get from "lodash/get";
import cloneDeep from "lodash/cloneDeep";
import filter from "lodash/filter";
import reject from "lodash/reject";
import dropWhile from "lodash/dropWhile";
import assign from "lodash/assign";
import sortBy from "lodash/sortBy";
import pick from "lodash/pick";
import merge from "lodash/merge";
import isString from "lodash/isString";
import keys from "lodash/keys";
import isBoolean from "lodash/isBoolean";
import reduce from "lodash/reduce";
import last from "lodash/last";
import initial from "lodash/initial";
import has from "lodash/has";
import find from "lodash/find";
import extend from "lodash/extend";
import each from "lodash/each";
import isArray from "lodash/isArray";
import defaults from "lodash/defaults";
import isNull from "lodash/isNull";
import isUndefined from "lodash/isUndefined";
import includes from "lodash/includes";
import isEmpty from "lodash/isEmpty";
import bind from "lodash/bind";
import union from "lodash/union";
import values from "lodash/values";
import isNumber from "lodash/isNumber";
import omit from "lodash/omit";
import map from "lodash/map";
import every from "lodash/every";
import isObject from "lodash/isObject";
import isFunction from "lodash/isFunction";
import flatten from "lodash/flatten";
import sample from "lodash/sample";
import isNil from "lodash/isNil";
import set from "lodash/set";
import intersection from "lodash/intersection";
import compact from "lodash/compact";

module.exports = {
  get : _get,
  set : set,
  cloneDeep: cloneDeep,
  map: map,
  sample,
  filter,
  flatten,
  isNil,
  reject,
  dropWhile,
  assign,
  find,
  sortBy,
  merge,
  isString,
  isUndefined,
  isNull,
  defaults,
  isArray,
  each,
  extend,
  has,
  initial,
  last,
  reduce,
  includes,
  isBoolean,
  keys,
  isEmpty,
  bind,
  union,
  pick,
  values,
  isNumber,
  omit,
  every,
  isObject,
  isFunction,
  intersection,
  compact
};



// WEBPACK FOOTER //
// ./src/ui/app/externals/lodash.js